import React, { useEffect, useState } from 'react'
import MainLayout from '../../components/layout/MainLayout'
import userService from '../../services/userService'

const UserList: React.FC = () => {
  const [data, setData] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [q, setQ] = useState('')
  const [role, setRole] = useState('')
  const [active, setActive] = useState('')

  const load = async () => {
    setLoading(true)
    try {
      const res: any = await userService.getUsers({ search: q || undefined, role: role || undefined, is_active: active === '' ? undefined : active })
      setData(res.data)
    } finally { setLoading(false) }
  }

  useEffect(() => { load() }, [])

  return (
    <MainLayout>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold">Usuarios</h2>
        <div className="flex gap-2">
          <input className="border rounded px-2 py-1" placeholder="Buscar" value={q} onChange={(e) => setQ(e.target.value)} />
          <select className="border rounded px-2 py-1" value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="">Todos los roles</option>
            <option value="admin">Administrador</option>
            <option value="moderator">Moderador</option>
            <option value="user">Usuario</option>
          </select>
          <select className="border rounded px-2 py-1" value={active} onChange={(e) => setActive(e.target.value)}>
            <option value="">Todos</option>
            <option value="1">Activos</option>
            <option value="0">Inactivos</option>
          </select>
          <button className="px-3 py-1 rounded bg-blue-600 text-white" onClick={load}>Aplicar</button>
        </div>
      </div>
      {loading ? (
        <div>Cargando...</div>
      ) : (
        <div className="overflow-x-auto bg-white rounded shadow">
          <table className="min-w-full">
            <thead>
              <tr className="text-left">
                <th className="px-3 py-2">Usuario</th>
                <th className="px-3 py-2">Nombre Completo</th>
                <th className="px-3 py-2">Email</th>
                <th className="px-3 py-2">Rol</th>
                <th className="px-3 py-2">Estado</th>
              </tr>
            </thead>
            <tbody>
              {data.map((u) => (
                <tr key={u.id} className="border-t">
                  <td className="px-3 py-2">{u.username}</td>
                  <td className="px-3 py-2">{u.full_name}</td>
                  <td className="px-3 py-2">{u.email}</td>
                  <td className="px-3 py-2">{u.role}</td>
                  <td className="px-3 py-2">
                    <span className={`px-2 py-1 rounded text-xs ${u.is_active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                      {u.is_active ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </MainLayout>
  )
}

export default UserList


